import { LoginUserDto } from "../entities/dto/auth.dto";
import { LoginResponse } from "../entities/interfaces/auth";
import Api, { ApiResponse } from "../utils/axios";

export const login = async (
  data: LoginUserDto
): Promise<ApiResponse<LoginResponse>> => {
  return await Api.post("/auth/login", data);
};

const AuthService = { login };
export default AuthService;
